import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export class SetJusteradPrestationCommand extends BasicCommand<SetJusteradPrestationCommand> {
    get primaryKey(): IPrimaryKey<SetJusteradPrestationCommand> {
        return {
            arbetsorderId: this.arbetsorderId
        };
    }
    arbetsorderId: number;
    justeradPrestation?: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Arbetsorder";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "SetJusteradPrestationCommand";
    constructor(init: (instance: SetJusteradPrestationCommand) => void) {
        super(SetJusteradPrestationCommand.$type, SetJusteradPrestationCommand.$groupKey, CommandType.Replace);
        init(this);
    }
}
